module.exports = __webpack_public_path__ + "img/STRAT.6ce0d10d.svg";